$(document).ready(function(){
  window.isEmpty=function(obj){
    for(var prop in obj){if(Object.prototype.hasOwnProperty.call(obj,prop)){return false;}}
    return JSON.stringify(obj)===JSON.stringify({});
  };

  window.update_cart=function(){
    var updates={};
    var vflag=sessionStorage.getItem("exclude_vat")||"false";
    document.querySelectorAll('.cart__items .cart__item,[data-products] .cart__item').forEach(function(elem){
      if(vflag!=elem.getAttribute('extax_flg')&&elem.getAttribute('data-tax-id')!=""){
        updates[elem.getAttribute('data-id')]=0;
        updates[elem.getAttribute('data-tax-id')]=elem.getAttribute('data-qty');
      }
    });
    if(window.isEmpty(updates)) return;
    fetch('/cart/update.js',{
      method:'POST',
      body:JSON.stringify({updates:updates}),
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}
    }).then(function(response){return response.json();}).then(function(){
      document.dispatchEvent(new Event('cart:build'));
    });
  };

  function syncVatUi(){
    var excluded=sessionStorage.getItem("exclude_vat")==="true";
    $('.chk_opt').prop('checked',excluded);
    $('#ex_vat_note').val(excluded?'VAT charges not applied':'VAT charges applied');
    $('.cd-vat-status').text(excluded?'VAT relief selected — eligible items will be shown excluding VAT.':'VAT is currently included. Tick the box if you qualify.').toggleClass('is-active',excluded);
  }

  if(sessionStorage.getItem("exclude_vat")===null){sessionStorage.setItem("exclude_vat","false");}
  syncVatUi();
  setTimeout(window.update_cart,1200);

  $(document).on('change','.chk_opt',function(){
    sessionStorage.setItem("exclude_vat",$(this).is(':checked')?'true':'false');
    syncVatUi();
    window.update_cart();
  });

  document.addEventListener('cart:build',function(){setTimeout(syncVatUi,250);});
});
